/**
 * Joins class names, filtering out falsy values.
 * @param {...string} classes - Class name strings or falsy values to ignore
 * @returns {string} Space-joined truthy class names
 */
export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
